/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPatientDetails } from './HchbPatientDetails';
import {
    HchbPatientDetailsFromJSON,
    HchbPatientDetailsFromJSONTyped,
    HchbPatientDetailsToJSON,
    HchbPatientDetailsToJSONTyped,
} from './HchbPatientDetails';

/**
 * 
 * @export
 * @interface FindOneHchbPatientDetails200Response
 */
export interface FindOneHchbPatientDetails200Response {
    /**
     * 
     * @type {HchbPatientDetails}
     * @memberof FindOneHchbPatientDetails200Response
     */
    data?: HchbPatientDetails;
}

/**
 * Check if a given object implements the FindOneHchbPatientDetails200Response interface.
 */
export function instanceOfFindOneHchbPatientDetails200Response(value: object): value is FindOneHchbPatientDetails200Response {
    return true;
}

export function FindOneHchbPatientDetails200ResponseFromJSON(json: any): FindOneHchbPatientDetails200Response {
    return FindOneHchbPatientDetails200ResponseFromJSONTyped(json, false);
}

export function FindOneHchbPatientDetails200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOneHchbPatientDetails200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : HchbPatientDetailsFromJSON(json['data']),
    };
}

export function FindOneHchbPatientDetails200ResponseToJSON(json: any): FindOneHchbPatientDetails200Response {
    return FindOneHchbPatientDetails200ResponseToJSONTyped(json, false);
}

export function FindOneHchbPatientDetails200ResponseToJSONTyped(value?: FindOneHchbPatientDetails200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': HchbPatientDetailsToJSON(value['data']),
    };
}

